(function() {
  var CADEAU_TYPE = 'cadeau';
  var MAX_QTY = 1;

  function isCadeau(item) {
    return item.product_type && item.product_type.trim().toLowerCase() === CADEAU_TYPE;
  }

  function getUpdates(cart) {
    var totals = {};
    var updates = {};

    if (!cart || !Array.isArray(cart.items)) return updates;

    cart.items.forEach(function(item) {
      if (!isCadeau(item)) return;
      var variantId = String(item.variant_id);
      totals[variantId] = (totals[variantId] || 0) + item.quantity;
    });

    Object.keys(totals).forEach(function(variantId) {
      if (totals[variantId] > MAX_QTY) updates[variantId] = MAX_QTY;
    });

    return updates;
  }

  function enforceCart(cart) {
    var updates = getUpdates(cart);
    if (!Object.keys(updates).length) return;

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function() {
      window.location.reload();
    }).catch(function() {});
  }

  function checkInitialCart() {
    fetch(window.routes.cart_url + '.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(response) {
      return response.json();
    }).then(enforceCart).catch(function() {});
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      enforceCart(event && event.cartData);
    });
  }

  function setup() {
    checkInitialCart();
    subscribeToCartUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
